import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';
import { apiRequestCommon } from './apiRequestCommon';
import { API_MYSTORE_REQUEST_BASE_PATH } from './const';
import { getCSRFPlugin } from './plugins';

export const apiV1MystoreRequest = createRequest({
    ...apiRequestCommon,

    /**
     * Настройка baseUrl для MyStore API:
     *
     * Используется единая схема как для SSR, так и для клиента:
     * - SSR: __API_ORIGIN__ (из apiRequestCommon) + /api/mystore/v1
     * - Клиент: запросы идут на /api/mystore/v1 и проксируются на __API_ORIGIN__
     *
     * Пример: '/api/mystore/v1/user/info' → 'https://core.yastore.yandex.ru/api/mystore/v1/user/info'
     */
    baseUrl:
        typeof window === 'undefined' ? __API_ORIGIN__ + API_MYSTORE_REQUEST_BASE_PATH : API_MYSTORE_REQUEST_BASE_PATH,

    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
    },
    jsonContentTypeHeaders: ['application/json'],
    plugins: [
        getProxyHeadersPlugin([
            'x-original-host',
            'cookie',
            'user-agent',
            'accept-language',
            'x-forwarded-for',
            'x-forwarded-for-y',
            'x-real-ip',
            'x-trace-id',
            'traceparent',
        ]),
        getCSRFPlugin(),
    ],
});
